import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import { IWorkflowType } from "@/interfaces/workflow-type.interface";
import workflowTypeService from "@/services/workflow-type.service";
import { PaginatedResponse, RequestPagination, RequestsBaseReturn } from "@/types/requests.types";

export type UseGetAllWorkflowTypesReturn =
  RequestsBaseReturn<PaginatedResponse<IWorkflowType> | null>;

export type UseGetAllWorkflowTypesProps = Partial<RequestPagination>;

type GetAllSwrParams = [string, number, number];

/** Sincroniza com o backoffice: refetch ao focar na aba, ao reconectar e em intervalo. */
const useGetAllWorkflowTypes = (
  props?: UseGetAllWorkflowTypesProps
): UseGetAllWorkflowTypesReturn => {
  const { pageNumber = 1, pageSize = 100 } = props || {};

  const {
    data = null,
    isValidating: isLoading,
    error,
  } = useSWR<PaginatedResponse<IWorkflowType>, Error, GetAllSwrParams>(
    [SWR_KEYS.getAllWorkflowTypes, pageNumber, pageSize],
    ([, _pageNumber, _pageSize]) =>
      workflowTypeService.getAllWorkflowTypes({
        pageNumber: _pageNumber,
        pageSize: _pageSize,
      }),
    {
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
      refreshInterval: 90_000,
    }
  );

  return { data, isLoading, error };
};

export default useGetAllWorkflowTypes;
